import {Forme, Perso} from "./Perso";
import {
    AgaricusBisporus,
    AmanitaMuscaria, BoletusEdulis, CantharellusCibarius,
    LactariusDeliciosus,
    MorchellaEsculenta,
    PleurotusOstreatus,
} from "../donnees/images";
import {compterNbDeChampisEnDigestion} from "../fonctions/Champignons";

export enum ChampignonEnum {
    oeil_de_lynx = "Agaricus bisporus",
    Huge = "Amanita muscaria",
    Overexcited = "Boletus edulis",
    Intuition_Escargot = "Cantharellus cibarius",
    Confused_Boar = "Lactarius deliciosus",
    Transformer = "Pleurotus ostreatus",
    Poison  = "Morchella esculenta",
}

export type Champignon = {
    nom: ChampignonEnum,
    effet: (perso: Perso) => string,
    secondesDEffet: number, // temps de départ à l'ingestion, diminue ensuite
    imageSrc: string,
    description: string,
    proba?: number,
}

export type ChampignonsObj = Record<ChampignonEnum, Champignon>;

export const champignons: ChampignonsObj = {
    [ChampignonEnum.oeil_de_lynx]: {
        nom: ChampignonEnum.oeil_de_lynx,
        imageSrc: `${AgaricusBisporus}`,
        secondesDEffet: 6,
        description: "Lynx eye : double mushrooms found",
        effet: (perso: Perso) => {
            if (compterNbDeChampisEnDigestion(perso, ChampignonEnum.Transformer)>0) {
                // transformation
                perso.forme = Forme.lynx;
                return ChampignonEnum.Transformer + " with a " + ChampignonEnum.oeil_de_lynx + " ! ";
            }
            return "You ate a mushroom.";
        },
    },
    [ChampignonEnum.Huge]: {
        nom: ChampignonEnum.Huge,
        imageSrc: `${AmanitaMuscaria}`,
        secondesDEffet: 10,
        description: "Huge : 50% Faster but needs more food",
        effet: (perso: Perso) => {
            if (compterNbDeChampisEnDigestion(perso, ChampignonEnum.Transformer)>0) {
                // transformation
                perso.forme = Forme.escargot;
                return ChampignonEnum.Transformer + " with a " + ChampignonEnum.Intuition_Escargot + " ! ";
            }
            return "You ate a mushroom.";
        },
    },
    [ChampignonEnum.Overexcited]: {
        nom: ChampignonEnum.Overexcited,
        imageSrc: `${BoletusEdulis}`,
        secondesDEffet: 12,
        description: "Overexcited -1s to get next event",
        effet: (perso: Perso) => {
            if (compterNbDeChampisEnDigestion(perso, ChampignonEnum.Transformer)>0) {
                // transformation
                perso.forme = Forme.lynx;
                return ChampignonEnum.Transformer + " with a " + ChampignonEnum.oeil_de_lynx + " ! ";
            }
            return "You ate a mushroom.";
        },
    },
    [ChampignonEnum.Intuition_Escargot]: {
        nom: ChampignonEnum.Intuition_Escargot,
        imageSrc: `${CantharellusCibarius}`,
        secondesDEffet: 12,
        description: "Intuition : reveals the effect of all mushrooms in tooltips",
        effet: (perso: Perso) => {
            if (compterNbDeChampisEnDigestion(perso, ChampignonEnum.Transformer)>0) {
                // transformation
                perso.forme = Forme.escargot;
                return ChampignonEnum.Transformer + " with a " + ChampignonEnum.Intuition_Escargot + " ! ";
            }
            return "You ate a mushroom.";
        },
    },
    [ChampignonEnum.Confused_Boar]: {
        nom: ChampignonEnum.Confused_Boar,
        imageSrc: `${LactariusDeliciosus}`,
        secondesDEffet: 10,
        description: "?? Confused : go backward",
        effet: (perso: Perso) => {
            if (compterNbDeChampisEnDigestion(perso, ChampignonEnum.Transformer)>0) {
                // transformation
                perso.forme = Forme.sanglier;
                return ChampignonEnum.Transformer + " with a " + ChampignonEnum.Confused_Boar + " ! ";
            }
            return "You ate a mushroom.";
        },
    },
    [ChampignonEnum.Transformer]: {
        nom: ChampignonEnum.Transformer,
        imageSrc: `${PleurotusOstreatus}`,
        secondesDEffet: 10,
        description: "Transform yourself into something depending on the next mushroom you eat",
        effet: (perso: Perso) => {
            if (compterNbDeChampisEnDigestion(perso, ChampignonEnum.Transformer)>0) {
                // transformation
                perso.forme = Forme.sanglier;
                return ChampignonEnum.Transformer + " with a " + ChampignonEnum.Confused_Boar + " ! ";
            }
            return "You ate a mushroom.";
        },
    },
    [ChampignonEnum.Poison]: {
        nom: ChampignonEnum.Poison,
        imageSrc: `${MorchellaEsculenta}`,
        secondesDEffet: 10,
        description: "Poisoned : Make you hungry and slow",
        effet: (perso: Perso) => {
            if (compterNbDeChampisEnDigestion(perso, ChampignonEnum.Transformer)>0) {
                // transformation
                perso.forme = Forme.humain;
                return ChampignonEnum.Transformer + " with a " + ChampignonEnum.Poison + " ! ";
            }
            return "You ate a mushroom.";
        },
    },
}